import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../_components/common/Navbar';
import SideNavBar from '../../../_components/common/SideNavBar'
import { orgAdminAreaData } from '../OrgAdminArea/SidebarData'
import { memberLevels } from './formData';
import './index.css'
import UtilityNav from '../../../_components/common/UtilityNav';
import TableNew from '../../../_components/common/Table';
import ModalComponent from '../../../_components/common/Modal';
import tableSort from '../../../_components/common/Sort';
import { orgAdminAction } from '../../../_actions';


class MemberLevel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            orgId: null,
            modal: false,
            changeMemberLevel: false,
            sortType: false,
            checkBoxData: [],
            buttonData: [],
            updateModalState: false,
            updateMessage: null,
            memberLevelData: '',
            navData: [],
            
        }
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        this.props.dispatch(orgAdminAction.getMemberLevelHandler(id, () => { }))
        this.setState({
            orgId: id,
            buttonData: [
                {
                    id: 1,
                    name: 'Change Member Levels',
                    toggler: this.toggleChangeMemberLevelModal.bind(this),
                    togglerModal: this.state.changeMemberLevel,
                    disabled: 'disabled',
                    title: "Change Members Levels"
                }
            ]
        })
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.getMemberLevelResponse !== this.props.getMemberLevelResponse) {
            if (this.props.getMemberLevelResponse !== '') {
                this.setState({
                    memberLevelData: this.getReformatData(this.props.getMemberLevelResponse.order_by_level)
                })
            }
        }

        if(prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    compareBy(key) {
        return tableSort(key, this.state.sortType)
    }


    sortBy(columnKey, type) {
        this.setState({ sortType: type })
        let arrayCopy = this.getReformatData(this.props.getMemberLevelResponse.order_by_level)
        arrayCopy.sort(this.compareBy(columnKey));
        this.setState({ memberLevelData: arrayCopy });
    }

    toggleChangeMemberLevelModal(showModal) {
        this.setState({
            changeMemberLevel: showModal,
        })
        memberLevels.map(
            (data, i) => {
                this.resetData(data)
            }
        )
    }

    resetData(data) {
        data.value = '';
        if (data.validation.required === true) {
            data.valid = false;
        }
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    actionSelected(data) {

        let ids = []
        this.state.checkBoxData.map(
            (data, i) => {
                if (typeof (data.participant__user_level) === "number") {
                    ids.push(data.participant__id)
                }
            }
        )
        const fd = {
            "user_id": ids,
            "member_level": data.data.member_level
        }
        this.props.dispatch(orgAdminAction.changeMemberLevelHandler(fd, this.state.orgId, (data) => {
            this.setState({
                updateMessage: {
                    status: data.status,
                    text: `<div className = " text-center">
                    <p className = "font-weight-bold">${(data.status === 200 || data.status === 201) ? 'Success!' : 'Error!'}</p>
                    <p> ${data.data.message}.</p>
                </div>`,
                    heading: 'Change Member Levels',
                    headerColor: (data.status === 200 || data.status === 201) ? `` : `bg-danger`,
                    headingIcon: (data.status === 200 || data.status === 201) ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                },
                updateModalState: true
            })
        }
        ))
    }

    toggleEntireMemberLevelModal(showModal) {
        this.setState({
            changeMemberLevel: showModal,
        })
    }

    getSelectedData(data) {
        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, false)
            })
        }
    }

    selectAllAssessment(data, clickToggle) {
        const { buttonData } = this.state;
        clickToggle === true ?
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                        assessmentResponse: data
                    })
                }
            })
            :
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                        assessmentResponse: data
                    })
                }
            })
    }

    getMemberLevels = (response) => {
        const returnData = [];
        for (let i = 0; i < response.length; i++) {
            let count = 0;

            for (let j = 0; j < returnData.length; j++) {
                if (response[i].participant__user_level === returnData[j]) {
                    count = count + 1;
                }
            }
            if (count === 0) {
                returnData.push(response[i].participant__user_level)
            }
        }
        return returnData
    }

    getReformatData = (response) => {
        const returnData = []
        // const filterCheck = response.filter(data => 
        //     data.id === 3
        // )
        const getMemberLevels = this.getMemberLevels(response)
        for (let i = 0; i < getMemberLevels.length; i++) {
            returnData.push({
                'is_group_header': true,
                'rowCheck': false,
                'participant__user_level': "Level - " + getMemberLevels[i]
            })
            // for (let j = 0; j < response.length; j++) {
            response.filter((data, k) => {
                if (data.participant__user_level === getMemberLevels[i]) {
                    if (data.participant__team_member_user__organisation_team__team_name === null) {
                        data.participant__team_member_user__organisation_team__team_name = 'Organisation'
                    }
                    returnData.push({
                        ...data,
                        'is_group_header': false,
                        'rowCheck': true,
                    })
                }
            })

            //     if (response[j].participant__user_level === getMemberLevels[i]) {
            //         returnData.push({
            //             ...response[j],
            //             'is_group_header': false,
            //             'rowCheck': true,
            //         })
            //     }
            // }
        }
        return returnData
    }

    render() {
        const { getMemberLevelResponse } = this.props;

        const tables = {
            Team: [{
                name: 'User Email',
                key: 'participant__email',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                header: `is_group_header`,
                headerText: 'participant__user_level',
                rowCheck: 'rowCheck'
            },
            {
                name: 'Name',
                key: 'participant__full_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                link: ''
            },
            {
                name: 'Team Name',
                key: 'participant__team_member_user__organisation_team__team_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                link: ''
            }]
        }

        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={orgAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">MANAGE MEMBER LEVELS</h5>
                        <UtilityNav
                            actionButtons={
                                this.state.buttonData
                            }
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}

                        />
                        <p className="text-right">1 - Heightest Level (CEO)     99 - Lowest Level (Entry Level)</p>
                        {
                            getMemberLevelResponse !== '' &&
                            <TableNew
                                data={this.state.memberLevelData === '' ? this.getReformatData(getMemberLevelResponse.order_by_level) : this.state.memberLevelData}
                                columns={tables.Team}
                                checkbox="true"
                                selectCheckBox={this.selectAllAssessment.bind(this)}
                                getData={this.getSelectedData.bind(this)}
                                CheckKey={"id"}
                                sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                                sortType={this.state.sortType}
                            />
                        }

                        {
                            (getMemberLevelResponse === '') &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                &nbsp;Loading</p>
                        }

                        {
                            this.state.changeMemberLevel &&
                            <ModalComponent
                                showModal={this.state.changeMemberLevel}
                                heading="Change Member Levels"
                                formData={memberLevels}
                                action={this.actionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireMemberLevelModal.bind(this)}
                                footerFormSubmitButton={['Add', 'Cancel']}
                                selectKey={['parent_team_id']}
                                selects={['parent_team_name']}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }

                    </div>

                </ div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { getMemberLevelLoading } = state.getMemberLevel;
    const getMemberLevelError = state.getMemberLevel.error;
    const getMemberLevelResponse = (!getMemberLevelLoading && !getMemberLevelError) ? state.getMemberLevel.data.data.members : '';


    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        getMemberLevelResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(MemberLevel);


// WEBPACK FOOTER //
// ./src/_pages/Organzation/OrgAdminArea/MemberLevel.js